export const DELIVERY_ADDRESS_MODAL = {
  title: 'delivery-address-modal',
  id: 'delivery-address-modal-id',
  loginButtonTestId: 'delivery-address-modal-login-button',
  saveCheckmarkTestId: 'delivery-address-modal-save-checkmark',
  form: 'addressform',
  addressInput: 'delivery-address-modal-address-input',
  address2Input: 'delivery-address-modal-address2-input',
  preferenceDropdownInput: 'delivery-address-modal-dropdown',
  specialInstructionsInput: 'delivery-address-modal-special-instructions',
  deliveryInstructionsBtn: 'special-instructions',
  continueButtonTestId: 'delivery-address-modal-continue-button',
  switchToPickUp: 'delivery-address-modal-switch-to-pickup',
  enterNewAddress: 'delivery-address-modal-enter-new-address',
  deliveryModalLayout: 'three-part-layout',
  contactlessOption: 'contactless',
  meetDoorOption: 'meetDoor'
};

export const DELIVERY_OPTIONS = ['contactless', 'meetDoor'];
